import { styled, Box, Button } from "@mui/material";

export const InteractiveButtonsRoot = styled(Box)(({ theme, show }) => {
  return {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: theme?.palette?.companyColors?.greyLight4,
    color: theme?.palette?.text?.primary,
    zIndex: 100,
    overflow: "hidden",
  };
});

export const PanelContent = styled(Box)(({ theme, show }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  justifyContent: "stretch",
  pointerEvents: show ? "auto" : "none",
  transition: "opacity 0.3s ease-in-out-in-out",
  height: "100%",
  overflow: "hidden",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

export const ContentTop = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  padding: "1rem 1.5rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  background: theme?.palette?.companyColors?.greyLight3,
}));

export const ContentBottom = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  padding: "1rem 1.5rem",
  borderTop: `1px solid ${theme.palette.divider}`,
  background: theme?.palette?.companyColors?.neutral,
  boxShadow: "0 -3px 10px rgba(0,0,0,0.15)",
}));

export const TabIcon = styled("img")(({ theme }) => ({
  width: 25,
  display: "block",
}));

// --- Collapsible Category Container ---
export const CategorySection = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme?.palette?.companyColors?.greyLight2}`,
  borderRadius: theme?.borderRadius?.medium,
  background: `rgba(${theme?.palette?.companyColors?.neutralRGB}, 0.5)`,
  padding: "1.5rem 2rem",
}));

export const CategoryHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
}));

export const SubCategoryRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  marginBottom: "2rem",
}));

export const OptionGrid = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "2rem",
  alignItems: "center",
}));

// -------------------------- Cinematic Buttons --------------------------

export const CinematicControls = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "1rem",
  position: "fixed",
  right: "auto",
  bottom: show ? 0 : "-15vh",
  top: "auto",
  left: "50%",
  margin: "auto",
  zIndex: 9,
  transition: "all ease-in-out-in-out 0.5s",
  padding: "2vh 3vw 3vh",
  [theme.breakpoints.down("lg")]: {
    padding: "2vh 5vw 3vh",
  },
  [theme.breakpoints.down("md")]: {
    left: "13rem",
    transform: "none",
    bottom: "1.5rem",
    padding: 0,
    "@media (orientation: landscape)": {
      left: "auto",
      right: "24rem",
      bottom: "5vh",
    },
  },
  [theme.breakpoints.down("sm")]: {
    left: "auto",
    right: "1.8rem",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    // background: "linear-gradient(0deg, rgba(255, 255, 255, 1) 60%, rgba(255, 255, 255, 0) 95%)",
    transition: "all linear 0.5s",
    bottom: show ? 0 : "-10vh",
    left: 0,
    righ: 0,
    zIndex: -1,
    [theme.breakpoints.up("md")]: {
      bottom: show ? 0 : "-15vh",
      background:
        "linear-gradient(0deg, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 115%)",
    },
  },
}));

export const CinematicButton = styled(Button)(({ theme, active }) => ({
  width: "3.6rem",
  height: "3.6rem",
  minWidth: 0,
  minHeight: 0,
  padding: 0,
  borderRadius: "4px",
  // background: "#fa0",
  // color: "#fff",
  background: "#071A3D",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  transition: "all ease-in-out-out 0.3s 0s",
  boxSizing: "border-box",
  "& img": {
    height: "1.6rem",
    width: "auto",
    // filter: "brightness(0) invert(0)",
    filter: "brightness(0) invert(1)",
  },
  ":hover": {
    "@media (hover: hover) and (pointer: fine)": {
      // background: "rgba(255,170,0, 0.3)",
      background: "rgba(7,26,61, 0.75)",
    },
    "@media (hover: none)": {
      // background: "rgba(255,170,0, 0.3)",
      background: "rgba(7,26,61, 0.75)",
    },
  },
}));

export const ToggleMenuBtn = styled(Box, {
  shouldForwardProp: (prop) => prop !== "show" && prop !== "isMobile",
})(({ theme, show, isMobile }) => ({
  position: "absolute",
  zIndex: 30,
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: theme?.palette?.companyColors?.accent,
  color: theme?.palette?.companyColors?.secondary,
  transition: "all 0.3s ease-in-out",
  pointerEvents: "auto",
  borderRadius: isMobile ? "4px 4px 0 0" : "4px 0 0 4px",
  // ===== DESKTOP POSITION =====
  ...(!isMobile && {
    top: "50%",
    left: 0,
    transform: "translate(-100%, -50%)",
    width: 34,
    height: 56,
  }),

  // ===== MOBILE POSITION =====
  ...(isMobile && {
    top: 0,
    right: -20,
    transform: "translate(-50%, -100%)", // above menu
    width: 50,
    height: 25,
  }),

  "& svg": {
    transform: show
      ? isMobile
        ? "rotate(0deg)" // ▲ when menu is open
        : "rotate(-90deg)" // desktop left arrow
      : isMobile
      ? "rotate(-180deg)" // ▼ when closed
      : "rotate(90deg)", // desktop right arrow
    transition: "transform 0.3s ease-in-out",
  },

  "&:hover": {
    background: theme?.palette?.companyColors?.secondary,
    color: theme?.palette?.companyColors?.accent,
  },

  [theme.breakpoints.up("lg")]: {
    ...(!isMobile && { width: 38, height: 70 }),
  },
}));

export const Divider = styled(Box)(({ theme, height }) => ({
  height: height ? height : "100%",
  position: "relative",
  width: "1px",
  display: "block",
  zIndex: 99,
  background: theme?.palette?.companyColors?.greyLight1,
}));
